import Swiper from "swiper";
import {
	Autoplay,
	EffectCoverflow,
	EffectCreative,
	EffectFade,
	Keyboard,
	Mousewheel,
	Navigation,
	Pagination,
	Thumbs,
} from "swiper/modules";
import { countUpInit } from "./helper";
/**
 * @param swiperInit
 */
export function swiperInit() {
	swiperSlide();
	swiperTimeline();
	swiperBanner();
	swipeRecruitment();
	swipePartner();
	swiperServiceDetailOther();
	//   new Swiper(".section-home-banner .swiper", {
	//     slidesPerView: 1,
	//     spaceBetween: 0,
	//     speed: 1000,
	//     loop: true,
	//     effect: "fade",
	//     autoplay: {
	//       delay: 3500,
	//     },
	//     modules: [Pagination, Navigation, Autoplay, EffectFade],
	//     pagination: {
	//       el: ".section-home-banner .swiper-pagination",
	//       clickable: true,
	//       renderBullet: function (index, className) {
	//         const slide = this.slides[index];
	//         const title = slide.getAttribute("data-title") || `Slide ${index + 1}`;
	//         return `<span class="${className}">${title}</span>`;
	//       },
	//     },
	//     navigation: {
	//       nextEl: ".section-home-banner .btn-next",
	//       prevEl: ".section-home-banner .btn-prev",
	//     },
	//   });
	// Reuseable Swiper
	$(".swiper-cols-1 .swiper").each(function () {
		new Swiper(this, {
			slidesPerView: 1,
			spaceBetween: 20,
			modules: [Navigation, Autoplay],
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: $(this).closest(".swiper-cols-1").find(".btn-next")[0],
				prevEl: $(this).closest(".swiper-cols-1").find(".btn-prev")[0],
			},
		});
	});
	$(".swiper-cols-2 .swiper").each(function () {
		new Swiper(this, {
			slidesPerView: 1,
			spaceBetween: 20,
			modules: [Navigation],
			navigation: {
				nextEl: $(this).closest(".swiper-cols-2").find(".btn-next")[0],
				prevEl: $(this).closest(".swiper-cols-2").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 40,
				},
			},
		});
	});
	// $(".swiper-cols-3 .swiper").each(function () {
	// 	new Swiper(this, {
	// 		slidesPerView: 1,
	// 		spaceBetween: 20,
	// 		modules: [Navigation],
	// 		navigation: {
	// 			nextEl: $(this).closest(".swiper-cols-3").find(".btn-next")[0],
	// 			prevEl: $(this).closest(".swiper-cols-3").find(".btn-prev")[0],
	// 		},
	// 		breakpoints: {
	// 			768: {
	// 				slidesPerView: 2,
	// 			},
	// 			1200: {
	// 				slidesPerView: 3,
	// 				spaceBetween: 40,
	// 			},
	// 		},
	// 	});
	// });
	// $(".swiper-cols-4 .swiper").each(function () {
	// 	new Swiper(this, {
	// 		slidesPerView: 1,
	// 		spaceBetween: 20,
	// 		modules: [Navigation],
	// 		navigation: {
	// 			nextEl: $(this).closest(".swiper-cols-4").find(".btn-next")[0],
	// 			prevEl: $(this).closest(".swiper-cols-4").find(".btn-prev")[0],
	// 		},
	// 		breakpoints: {
	// 			768: {
	// 				slidesPerView: 3,
	// 			},
	// 			1200: {
	// 				slidesPerView: 4,
	// 				spaceBetween: 40,
	// 			},
	// 		},
	// 	});
	// });
}

function swiperBanner() {
	const swiper = new Swiper(".banner-swiper", {
		modules: [Autoplay, Navigation, Pagination],
		autoHeight: false,
		pagination: {
			el: ".banner-swiper-dots", // Dot pagination
			clickable: true,
			bulletClass: "swiper-pagination-bullet",
			bulletActiveClass: "swiper-pagination-bullet-active",
		},
		speed: 1500,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		on: {
			init: function () {
				const totalSlides = this.slides.length;
				document.querySelector(".pagination-total").textContent = totalSlides;

				// Thiết lập tiến trình ban đầu
				const progressBar = document.querySelector(".progress-bar");
				const progress = ((this.activeIndex + 1) / totalSlides) * 150; // Tính toán theo pixel
				progressBar.style.width = `${progress}px`; // Gán chiều rộng bằng px
			},
			slideChange: function () {
				const currentSlide = this.activeIndex + 1; // Số slide hiện tại
				const totalSlides = this.slides.length; // Tổng số slide

				// Cập nhật số slide
				document.querySelector(".pagination-current").textContent = currentSlide;

				// Cập nhật thanh tiến trình
				const progressBar = document.querySelector(".progress-bar");
				const progress = (currentSlide / totalSlides) * 150; // Tính toán lại theo pixel
				progressBar.style.width = `${progress}px`; // Gán chiều rộng bằng px
			},
		},
	});

	const swiperBannerMobile = new Swiper(".swiper-banner-mobile", {
		modules: [Autoplay, Navigation, Pagination],
		pagination: {
			el: ".banner-swiper-dots-mobile", // Dot pagination
			clickable: true,
			bulletClass: "swiper-pagination-bullet-mobile",
			bulletActiveClass: "swiper-pagination-bullet-active-mobile",
		},
		slidesPerView: 1,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		loop: true,
		on: {
			init: function () {
				const totalSlides = this.slides.length;
				document.querySelector(".pagination-total-mobile").textContent = totalSlides;

				// Thiết lập tiến trình ban đầu
				const progressBar = document.querySelector(".progress-bar-mobile");
				const progress = ((this.activeIndex + 1) / totalSlides) * 150; // Tính toán theo pixel
				progressBar.style.width = `${progress}px`; // Gán chiều rộng bằng px
			},
			slideChange: function () {
				const currentSlide = this.activeIndex + 1; // Số slide hiện tại
				const totalSlides = this.slides.length; // Tổng số slide

				// Cập nhật số slide
				document.querySelector(".pagination-current-mobile").textContent = currentSlide;

				// Cập nhật thanh tiến trình
				const progressBar = document.querySelector(".progress-bar-mobile");
				const progress = (currentSlide / totalSlides) * 150; // Tính toán lại theo pixel
				progressBar.style.width = `${progress}px`; // Gán chiều rộng bằng px
			},
		},
	});
}

function swiperTimeline() {
	const swiperTimeline = new Swiper(".timeline-swiper", {
		modules: [Autoplay, Navigation],
		spaceBetween: 20,
		slidesPerView: 1,
		centeredSlides: true,
		freeMode: true,
		initialSlide: 2,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		on: {
			slideChange: function () {
				// Reset tất cả SVG
				const icons = document.querySelectorAll(".swiper-slide .icon svg");
				icons.forEach((icon) => {
					// Đặt lại SVG mặc định
					icon.innerHTML = `<circle cx="18" cy="17.5" r="13" fill="#F5F5F5" stroke="#243EA3"/>`;
					icon.setAttribute("width", "36");
					icon.setAttribute("height", "35");
					icon.setAttribute("viewBox", "0 0 36 35");
				});

				// Cập nhật SVG mới cho slide hiện tại
				const activeSlide = this.slides[this.activeIndex];
				const activeIcon = activeSlide.querySelector(".icon svg");

				activeIcon.innerHTML = `
        <circle cx="18" cy="17.5" r="17" fill="#F5F5F5" stroke="#EC1B24"/>
        <circle cx="18" cy="17.5" r="13.5" fill="#EC1B24"/>
      `;
				activeIcon.setAttribute("width", "36");
				activeIcon.setAttribute("height", "35");
				activeIcon.setAttribute("viewBox", "0 0 36 35");
			},
		},
		// Thêm sự kiện click vào SVG để chuyển slide

		speed: 1000,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 160,
			},
		},

		navigation: {
			nextEl: ".timeline-btn-next",
			prevEl: ".timeline-btn-prev",
		},
	});
	const icons = document.querySelectorAll(".swiper-slide .icon svg");
	icons.forEach((icon) => {
		icon.addEventListener("click", () => {
			swiperTimeline.slideNext();
		});
	});
}

function swiperSlide() {
	const swiperNewsRelated = new Swiper(".news-related-swiper", {
		modules: [Autoplay, Navigation],
		spaceBetween: 20,
		slidesPerView: 1,
		freeMode: true,
		loop: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		speed: 1000,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 40,
			},
		},

		navigation: {
			nextEl: ".news-btn-next",
			prevEl: ".news-btn-prev",
		},
	});

	const swiperServiceDetail = new Swiper(".service-detail-swiper", {
		modules: [Autoplay, Navigation],
		slidesPerView: 1,
		freeMode: true,
		spaceBetween: 20,
		loop: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		speed: 1000,
		breakpoints: {
			768: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 1,
			},
		},

		navigation: {
			nextEl: ".service-btn-next",
			prevEl: ".service-btn-prev",
		},
	});

	const swiperStaff = new Swiper(".staff-swiper", {
		modules: [Autoplay, Navigation],
		slidesPerView: 1,
		freeMode: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		speed: 1000,
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 5, // Đảm bảo là đúng
				spaceBetween: 20,
			},
		},

		navigation: {
			nextEl: ".staff-btn-next",
			prevEl: ".staff-btn-prev",
		},
	});

	const swiperCompany = new Swiper(".company-swiper", {
		modules: [Autoplay, Navigation, EffectCoverflow],
		slidesPerView: "auto",
		grabCursor: true,
		// autoplay: {
		//   delay: 5000,
		//   disableOnInteraction: false,
		// },
		speed: 1000,
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 3, // Đảm bảo là đúng
				spaceBetween: 20,
			},
		},

		navigation: {
			nextEl: ".company-btn-next",
			prevEl: ".company-btn-prev",
		},
	});
}

function swipeRecruitment() {
	const swiperRecruitment = new Swiper(".home-6-swiper", {
		modules: [Autoplay, Navigation],
		slidesPerView: 1,
		spaceBetween: 20,
		freeMode: true,
		// autoplay: {
		// 	delay: 5000,
		// 	disableOnInteraction: false,
		// },
		loop: true,
		speed: 1000,
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 20,
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
				},
				loop: true,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 3.2,
				spaceBetween: 19,
			},
		},

		navigation: {
			nextEl: ".recruitment-btn-next",
			prevEl: ".recruitment-btn-prev",
		},
	});
}

function swiperServiceDetailOther() {
	const swiperRecruitment = new Swiper(".swiper-service-detail-other", {
		modules: [Autoplay, Navigation],
		slidesPerView: 1,
		spaceBetween: 20,
		freeMode: true,
		// autoplay: {
		// 	delay: 5000,
		// 	disableOnInteraction: false,
		// },
		loop: true,
		speed: 1000,
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 20,
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
				},
				loop: true,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 40,
			},
		},

		navigation: {
			nextEl: ".service-detail-5 .service-detail-btn-next",
			prevEl: ".service-detail-5 .service-detail-btn-prev",
		},
	});
}

function swipePartner() {
	const swiperPartner = new Swiper(".swiper-partner", {
		modules: [Autoplay, Navigation],
		slidesPerView: 3,
		spaceBetween: 12,
		grabCursor: true,
		loop: true,
		speed: 4000,
		allowTouchMove: false,
		disableOnInteraction: false,
		autoplay: {
			delay: 1,
			waitForTransition: true,
		},
		breakpoints: {
			640: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 5,
				spaceBetween: 20,
				loop: true,
			},
			1024: {
				slidesPerView: 10,
				spaceBetween: 12,
				loop: true,
			},
			1200: {
				slidesPerView: 10,
				spaceBetween: 12,
				loop: true,
			},
		},
	});

	const swiperSlides = document.querySelectorAll(".swiper-partner .swiper-slide");
	swiperSlides.forEach((slide) => {
		slide.addEventListener("click", function () {
			swiperPartner.autoplay.stop();
			swiperPartner.params.slidesPerView = 10;
			swiperPartner.update();
		});
	});
}

export const Fullpage = {
	generateThumbs: function () {
		const slides = jQuery(".fullpage-swiper > .swiper > .swiper-wrapper > .swiper-slide");
		if (slides.length === 0) {
			console.error("No slides found in .fullpage-swiper");
			return;
		}
		slides.each(function (index) {
			let title = $(this).data("title");
			if (!title || slides.filter(`[data-title="${title}"]`).length > 1) {
				title = `${index + 1}`; // Gán tiêu đề tự động nếu trùng hoặc thiếu
			}
			let title_section = $(this).data("title-section");

			jQuery(".fullpage-slide-thumb .swiper-wrapper").append(
				`<div class="swiper-slide"><div class="item-thumb"><p>${title}</p><p class="title-section">${title_section}</p></div></div>`
			);
		});
	},

	swiper: function () {
		// Khởi tạo thumbnail swiper đơn giản
		const fullpage_thumb = new Swiper(".fullpage-slide-thumb .swiper", {
			direction: "vertical",
			speed: 600, // Tăng speed lên chút để mượt hơn
			observer: true,
			observeParents: true,
			slidesPerView: "auto",
			watchSlidesProgress: true,
			allowTouchMove: false,
		});

		// Khởi tạo main swiper
		const fullpage_main = new Swiper(".fullpage-swiper .swiper-full-current", {
			direction: "vertical",
			speed: 1000,
			observer: true,
			autoHeight: true,
			observeParents: true,
			spaceBetween: 0,
			slidesPerView: 1,
			allowTouchMove: false,
			modules: [Pagination, EffectCreative, Keyboard, Mousewheel, Navigation, Thumbs],
			mousewheel: {
				forceToAxis: true,
				thresholdTime: 1200,
			},
			thumbs: {
				swiper: fullpage_thumb,
			},
			keyboard: {
				enabled: true,
			},
			effect: "creative",
			creativeEffect: {
				prev: {
					translate: [0, "-100%", -1],
				},
				next: {
					translate: [0, "100%", 0],
				},
			},
			on: {
				init: () => {
					jQuery("header").addClass("header-black");
					jQuery(".fullpage-slide-thumb").addClass("active");
					updateActiveNumber();
				},

				beforeTransition: () => {
					// Thêm class để bắt đầu transition
					jQuery(".fullpage-slide-thumb .swiper-slide").addClass("transitioning");
				},
				beforeTransitionStart: async (swiper) => {
					console.log("beforeTransitionStart");
					const isCountUp =
						$(".swiper-full-current > .swiper-wrapper > .swiper-slide-active .section-swiper").find(
							".countup"
						).length > 0;
					if (isCountUp) {
						const countUp = countUpInit();
						countUp.reset();
						countUp.start();
					}
				},
				transitionEnd: () => {
					// Xóa class transition sau khi hoàn thành
					setTimeout(() => {
						jQuery(".fullpage-slide-thumb .swiper-slide").removeClass("transitioning");
					}, 300);
					updateActiveNumber();
				},
				afterInit: (swiper) => {
					const hash = window.location.hash.replace("#", "");
					if (hash) {
						const lastNumber = hash.split("-")[1];
						swiper.slideTo(lastNumber - 1);
					}
					updateActiveNumber();
				},
			},
		});

		// Hàm cập nhật số active với transition mượt
		function updateActiveNumber() {
			const activeSlide = jQuery(".swiper-full-current > .swiper-wrapper > .swiper-slide-active");
			const title = activeSlide.data("title");
			const activeIndex = activeSlide.index();

			requestAnimationFrame(() => {
				jQuery(".fullpage-slide-thumb .swiper-slide").removeClass("active all-white");

				if (title === "01" || title === "02" || title === "05" || title === "08") {
					jQuery(".fullpage-slide-thumb .swiper-slide").addClass("all-white");
				}

				jQuery(`.fullpage-slide-thumb .swiper-slide:eq(${activeIndex})`).addClass("active");
			});
		}

		// Button to top
		jQuery(".button-to-top").on("click", function () {
			fullpage_main.slideTo(0);
		});
	},

	init: function () {
		if (window.matchMedia("(min-width: 1200px)").matches) {
			Fullpage.generateThumbs();
			Fullpage.swiper();
		}
	},
};
